/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */
import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_DISCOVERY_FUND = 'ON_REQUEST_DISCOVERY_FUND';
const ON_REQUEST_DISCOVERY_FUND_FAILURE = 'ON_REQUEST_DISCOVERY_FUND_FAILURE';
const ON_REQUEST_DISCOVERY_FUND_SUCCESS = 'ON_REQUEST_DISCOVERY_FUND_SUCCESS';

function onRequestDiscoveryFund(resetData) {
  return {
    type: ON_REQUEST_DISCOVERY_FUND,
    meta: { resetData }
  };
}

function onRequestDiscoveryFundSuccess(payload) {
  return {
    type: ON_REQUEST_DISCOVERY_FUND_SUCCESS,
    payload
  };
}

function onRequestDiscoveryFundFailure(payload) {
  return {
    type: ON_REQUEST_DISCOVERY_FUND_FAILURE,
    payload
  };
}

export const onDoRequestDiscoveryFund = (payload, resetData = false) => (dispatch) => {
  dispatch(onRequestDiscoveryFund(resetData));
  Fetch.get(`${V1}mutualfund/fund-bundle/search/${payload}`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestDiscoveryFundSuccess(resp.json));
    } else {
      dispatch(onRequestDiscoveryFundFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestDiscoveryFundFailure(error.message));
  });
};

const ON_REQUEST_CATEGORY_DISCOVERY_FUND = 'ON_REQUEST_CATEGORY_DISCOVERY_FUND';
const ON_REQUEST_CATEGORY_DISCOVERY_FUND_FAILURE = 'ON_REQUEST_CATEGORY_DISCOVERY_FUND_FAILURE';
const ON_REQUEST_CATEGORY_DISCOVERY_FUND_SUCCESS = 'ON_REQUEST_CATEGORY_DISCOVERY_FUND_SUCCESS';

function onRequestCategoryDiscoveryFund() {
  return {
    type: ON_REQUEST_CATEGORY_DISCOVERY_FUND,
  };
}

function onRequestCategoryDiscoveryFundSuccess(payload) {
  return {
    type: ON_REQUEST_CATEGORY_DISCOVERY_FUND_SUCCESS,
    payload
  };
}

function onRequestCategoryDiscoveryFundFailure(payload) {
  return {
    type: ON_REQUEST_CATEGORY_DISCOVERY_FUND_FAILURE,
    payload
  };
}

export const onDoRequestCategoryDiscoveryFund = () => (dispatch) => {
  dispatch(onRequestCategoryDiscoveryFund());
  Fetch.get(`${V1}mutualfund/fund-bundle/category/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestCategoryDiscoveryFundSuccess(resp.json));
    } else {
      dispatch(onRequestCategoryDiscoveryFundFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestCategoryDiscoveryFundFailure(error.message));
  });
};

const ON_REQUEST_TYPE_DISCOVERY_FUND = 'ON_REQUEST_TYPE_DISCOVERY_FUND';
const ON_REQUEST_TYPE_DISCOVERY_FUND_FAILURE = 'ON_REQUEST_TYPE_DISCOVERY_FUND_FAILURE';
const ON_REQUEST_TYPE_DISCOVERY_FUND_SUCCESS = 'ON_REQUEST_TYPE_DISCOVERY_FUND_SUCCESS';

function onRequestTypeDiscoveryFund() {
  return {
    type: ON_REQUEST_TYPE_DISCOVERY_FUND,
  };
}

function onRequestTypeDiscoveryFundSuccess(payload) {
  return {
    type: ON_REQUEST_TYPE_DISCOVERY_FUND_SUCCESS,
    payload
  };
}

function onRequestTypeDiscoveryFundFailure(payload) {
  return {
    type: ON_REQUEST_TYPE_DISCOVERY_FUND_FAILURE,
    payload
  };
}

export const onDoRequestTypeDiscoveryFund = () => (dispatch) => {
  dispatch(onRequestTypeDiscoveryFund());
  Fetch.get(`${V1}common/fund-bundle/type/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestTypeDiscoveryFundSuccess(resp.json));
    } else {
      dispatch(onRequestTypeDiscoveryFundFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestTypeDiscoveryFundFailure(error.message));
  });
};

const INITIAL_STATE = {
  discoveryFundLoading: false,
  discoveryFundData: null,
  discoveryFundError: null,

  discoveryCategoryFundLoading: false,
  discoveryCategoryFundData: null,
  discoveryCategoryFundError: null,

  discoveryTypeFundLoading: false,
  discoveryTypeFundData: null,
  discoveryTypeFundError: null,
};

const mfDiscovery = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_CATEGORY_DISCOVERY_FUND:
      return {
        ...state,
        discoveryCategoryFundLoading: true,
        discoveryCategoryFundData: null,
        discoveryCategoryFundError: null,
      };
    case ON_REQUEST_CATEGORY_DISCOVERY_FUND_SUCCESS:
      return {
        ...state,
        discoveryCategoryFundLoading: true,
        discoveryCategoryFundData: action.payload,
        discoveryCategoryFundError: null,
      };
    case ON_REQUEST_CATEGORY_DISCOVERY_FUND_FAILURE:
      return {
        ...state,
        discoveryCategoryFundLoading: true,
        discoveryCategoryFundData: null,
        discoveryCategoryFundError: action.payload,
      };

    case ON_REQUEST_TYPE_DISCOVERY_FUND:
      return {
        ...state,
        discoveryTypeFundLoading: true,
        discoveryTypeFundData: null,
        discoveryTypeFundError: null,
      };
    case ON_REQUEST_TYPE_DISCOVERY_FUND_SUCCESS:
      return {
        ...state,
        discoveryTypeFundLoading: true,
        discoveryTypeFundData: action.payload,
        discoveryTypeFundError: null,
      };
    case ON_REQUEST_TYPE_DISCOVERY_FUND_FAILURE:
      return {
        ...state,
        discoveryTypeFundLoading: true,
        discoveryTypeFundData: null,
        discoveryTypeFundError: action.payload,
      };

    case ON_REQUEST_DISCOVERY_FUND:
      if (action.meta.resetData) {
        return {
          ...state,
          discoveryFundLoading: true,
          discoveryFundData: null,
          discoveryFundError: null
        };
      } else {
        return {
          ...state,
          discoveryFundLoading: true,
          discoveryFundError: null
        };
      }
    case ON_REQUEST_DISCOVERY_FUND_SUCCESS:
      if (state.discoveryFundData) {
        const oldResults = [...state.discoveryFundData.results];
        state.discoveryFundData = {
          ...action.payload,
          results: [
            ...oldResults,
            ...action.payload.results
          ]
        };
      } else {
        state.discoveryFundData = action.payload;
      }
      return {
        ...state,
        discoveryFundLoading: false,
        discoveryFundError: null
      };
    case ON_REQUEST_DISCOVERY_FUND_FAILURE:
      return {
        ...state,
        discoveryFundLoading: false,
        discoveryFundError: action.payload
      };
    default:
      return state;
  }
};

export default mfDiscovery;
